"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryReportBuilder = void 0;
const SummaryCounter_1 = require("./SummaryCounter");
class SummaryReportBuilder {
    #clientWarningMessages = [];
    #store = {
        api_response_code: 0,
        api_response_message: "",
        api_response_time_ms: 0,
        client_warning_message: "",
        page_url: "",
        normalized_page_url: "",
        execution_reason: "",
        execution_id: "",
        silent_mode: false,
        impression_id: "",
        browser_time: "",
        browser_agent: "",
        cards_count: 0,
        original_links_possible_to_be_updated: 0,
        original_links_updated: 0,
        original_links_possible_to_be_replaced: 0,
        original_links_replaced: 0,
        possible_additional_alternatives: 0,
        displayed_additional_alternatives: 0,
        cards_with_possible_alternatives: 0,
        cards_with_displayed_alternatives: 0,
        cards_with_possible_updates: 0,
        cards_with_updated_button: 0,
        cards_with_possible_replacement: 0,
        cards_with_replaced_button: 0,
        build_no: "",
        publisher_id: 0,
        publisher_domain_id: 0,
    };
    constructor(buildNo, publisherId, publisherDomainId) {
        this.#store.build_no = buildNo;
        this.#store.publisher_id = publisherId;
        this.#store.publisher_domain_id = publisherDomainId;
    }
    setApiResponseCode(value) {
        this.#store.api_response_code = value;
    }
    setApiResponseMessage(value) {
        this.#store.api_response_message = value;
    }
    setApiResponseTimeMs(value) {
        this.#store.api_response_time_ms = value;
    }
    appendClientWarningMessages(value) {
        this.#clientWarningMessages.push(value);
    }
    setPageUrl(value) {
        this.#store.page_url = value;
        this.#setNormalizedPageUrl(value);
    }
    #setNormalizedPageUrl(value) {
        let url = new URL(value);
        this.#store.normalized_page_url = url.hostname + url.pathname;
    }
    setExecutionReason(value) {
        this.#store.execution_reason = value;
    }
    setExecutionId(value) {
        this.#store.execution_id = value;
    }
    setSilentMode(value) {
        this.#store.silent_mode = value;
    }
    setCardCount(value) {
        this.#store.cards_count = value;
    }
    setImpressionId(value) {
        this.#store.impression_id = value;
    }
    setBrowserTime(value) {
        this.#store.browser_time = value;
    }
    setBrowserAgent(value) {
        this.#store.browser_agent = value;
    }
    setConfigVariantId(value) {
        if (value === undefined) {
            return;
        }
        this.#store.config_variant_id = value;
    }
    setCounts(counters) {
        for (let i = 0; i < this.#store.cards_count; i++) {
            // Getting the values per card
            let original_links_possible_to_be_updated = counters.getCountByIndexAndType(i, SummaryCounter_1.CountType.ORIGINAL_LINKS_POSSIBLE_TO_BE_UPDATED) ?? 0;
            let original_links_updated = counters.getCountByIndexAndType(i, SummaryCounter_1.CountType.ORIGINAL_LINKS_UPDATED) ?? 0;
            let original_links_possible_to_be_replaced = counters.getCountByIndexAndType(i, SummaryCounter_1.CountType.ORIGINAL_LINKS_POSSIBLE_TO_BE_REPLACED) ?? 0;
            let original_links_replaced = counters.getCountByIndexAndType(i, SummaryCounter_1.CountType.ORIGINAL_LINKS_REPLACED) ?? 0;
            let possible_additional_alternatives = counters.getCountByIndexAndType(i, SummaryCounter_1.CountType.POSSIBLE_ADDITIONAL_ALTERNATIVES) ?? 0;
            let displayed_additional_alternatives = counters.getCountByIndexAndType(i, SummaryCounter_1.CountType.DISPLAYED_ADDITIONAL_ALTERNATIVES) ?? 0;
            // Incrementing the total values per page
            this.#store.original_links_possible_to_be_updated += original_links_possible_to_be_updated;
            this.#store.original_links_updated += original_links_updated;
            this.#store.original_links_possible_to_be_replaced += original_links_possible_to_be_replaced;
            this.#store.original_links_replaced += original_links_replaced;
            this.#store.possible_additional_alternatives += possible_additional_alternatives;
            this.#store.displayed_additional_alternatives += displayed_additional_alternatives;
            // In#rementing placement areas
            this.#store.cards_with_possible_alternatives += possible_additional_alternatives > 0 ? 1 : 0;
            this.#store.cards_with_displayed_alternatives += displayed_additional_alternatives > 0 ? 1 : 0;
            this.#store.cards_with_possible_updates += original_links_possible_to_be_updated > 0 ? 1 : 0;
            this.#store.cards_with_updated_button += original_links_updated > 0 ? 1 : 0;
            this.#store.cards_with_possible_replacement += original_links_possible_to_be_replaced > 0 ? 1 : 0;
            this.#store.cards_with_replaced_button += original_links_replaced > 0 ? 1 : 0;
        }
    }
    build() {
        this.#store.client_warning_message = JSON.stringify(this.#clientWarningMessages);
        return this.#store;
    }
}
exports.SummaryReportBuilder = SummaryReportBuilder;
